module.exports = __webpack_public_path__ + "img/08-global-travel.329b8bb1.png";